import React, {useState,useEffect,useContext} from 'react'

import {Alert, Button, DatePicker, Form, Layout, Modal, Select, Space, Spin, Table, Tag} from "antd";

import {errorN, successN} from "../../general";
import {navigate} from "hookrouter";
import useFetch from "use-http";
import {StopOutlined} from '@ant-design/icons'
import {isMobile} from "react-device-detect";

import {Context} from "../../store"
import moment from 'moment'
import {getChannelAccess, getSyncPause, isChannelAdmin} from "./channelAccess";

const {Content} = Layout;
const {Option} = Select;

// Online Sales Control (stop sale), matches Windows frmAdmin_ChannelStop.cs.
function SalesControl(props) {
    const [state] = useContext(Context)
    const { get, post, response, loading} = useFetch()

    const [property, setProperty] = useState(null)
    const [propertyList, setPropertyList] = useState([])
    const [startDate, setStartDate] = useState(moment().startOf('day'))
    const [endDate, setEndDate] = useState(moment().startOf('day').add(1, 'days'))

    const [rows, setRows] = useState([])
    const [dates, setDates] = useState([])
    const [loaded, setLoaded] = useState(null)
    const [pending, setPending] = useState({})
    const [saving, setSaving] = useState(false)

    const access = getChannelAccess(state.role);
    const admin = isChannelAdmin(state.role !== undefined && state.role !== null && state.role !== '' ? state.role : localStorage.getItem('role'));
    const syncPause = getSyncPause();
    const pendingCount = Object.keys(pending).length;

    useEffect(() => {

        if(localStorage.getItem('session') === null)
        {
            navigate('/')
        }
        else
        {
            let current = JSON.parse(localStorage.getItem('currentproperty'));
            let list = [];

            try
            {
                list = JSON.parse(localStorage.getItem('properties'));
            }
            catch (err)
            {
                list = [];
            }

            if(list === undefined || list === null || !Array.isArray(list))
            {
                list = [];
            }

            if(current !== null && !list.some(x => x.id.toString() === current.id.toString()))
            {
                list.push(current);
            }

            setPropertyList(list);
            setProperty(current !== null ? current.id : null);
        }

        return () => {

        }
    },[state.currentproperty])

    // Changing property or dates throws away pending changes, so ask first.
    function confirmDiscard(apply) {
        if(pendingCount === 0)
        {
            apply();
            return;
        }

        Modal.confirm({
            title: 'Discard pending changes?',
            content: `You have ${pendingCount} unsaved change(s). They will be lost.`,
            okText: 'Discard',
            cancelText: 'Keep',
            onOk: () => {
                setPending({});
                setRows([]);
                setDates([]);
                setLoaded(null);
                apply();
            }
        });
    }

    function onPropertyChange(e) {
        confirmDiscard(() => { setProperty(e); setRows([]); setDates([]); setLoaded(null); });
    }

    function onStartChange(e) {
        if(e === null) return;
        confirmDiscard(() => { setStartDate(e.clone().startOf('day')); setRows([]); setDates([]); setLoaded(null); });
    }

    function onEndChange(e) {
        if(e === null) return;
        confirmDiscard(() => { setEndDate(e.clone().startOf('day')); setRows([]); setDates([]); setLoaded(null); });
    }

    async function loadData(hotel, s, e) {

        if(hotel === null || hotel === undefined)
        {
            errorN(`Please choose a property.`);
            return;
        }

        if(e.isBefore(s, 'day'))
        {
            errorN(`End date must be on or after the start date.`);
            return;
        }

        let start = s.format('YYYY-MM-DD');
        let end = e.clone().add(1, 'days').format('YYYY-MM-DD');

        let ls = [];
        for (let d = s.clone(); !d.isAfter(e, 'day'); d.add(1, 'days'))
        {
            ls.push(d.format('YYYY-MM-DD'));
        }

        try
        {
            let availabilityList = await get(`/api/channel/available?start=${start}&end=${end}&hotel=${hotel}`)
            if (response.ok)
            {
                let it = await get(`/api/hotels/${hotel}/items`)
                if (response.ok)
                {
                    let list = [];

                    for(let item of (availabilityList || []))
                    {
                        let row = {
                            id: item.id,
                            name: '',
                            cells: {}
                        };

                        for(let its of (it || []))
                        {
                            if(its.id.toString() === item.id.toString())
                            {
                                row.name = its.data.name;
                            }
                        }

                        for(let x = 0; x < ls.length; x++)
                        {
                            row.cells[ls[x]] = {
                                noOTA: item.noOTA !== undefined && item.noOTA !== null ? item.noOTA[x] : undefined,
                                avail: item.avail !== undefined && item.avail !== null ? item.avail[x] : undefined,
                                availRatri: item.availRatri !== undefined && item.availRatri !== null ? item.availRatri[x] : undefined
                            };
                        }

                        list.push(row);
                    }

                    setDates(ls);
                    setRows(list);
                    setPending({});
                    setLoaded({hotel: hotel, start: s.clone(), end: e.clone()});
                }
                else
                {
                    if(response.status === 401)
                    {
                        localStorage.removeItem('session');
                        window.location.reload();
                    }
                    else
                    {
                        errorN(`Load Item Data - ${response.status}: ${response.statusText}. Please contact the administrator.`);
                    }
                }
            }
            else
            {
                if(response.status === 401)
                {
                    localStorage.removeItem('session');
                    window.location.reload();
                }
                else
                {
                    errorN(`Load Data - ${response.status}: ${response.statusText}. Please contact the administrator.`);
                }
            }
        }
        catch(err)
        {
            errorN(`Error Load Data: ${err}. Please contact the administrator.`);
        }
    }

    function onLoad() {
        confirmDiscard(() => { loadData(property, startDate, endDate); });
    }

    function isStopped(cell) {
        return cell !== undefined && cell.noOTA !== undefined && cell.noOTA !== null && cell.noOTA !== 0;
    }

    function toggleCell(row, date) {
        let cell = row.cells[date];
        if(cell === undefined || cell.noOTA === undefined || cell.noOTA === null)
        {
            return;
        }

        let key = `${row.id}|${date}`;
        let next = {...pending};

        if(next[key] !== undefined)
        {
            delete next[key];
        }
        else
        {
            let stopped = isStopped(cell);
            next[key] = {
                id: row.id,
                name: row.name,
                date: date,
                from: stopped ? 'STOPPED' : 'Active',
                to: stopped ? 'Active' : 'STOPPED',
                noOTA: stopped ? 0 : 1
            };
        }

        setPending(next);
    }

    function onSave() {
        if(pendingCount === 0 || loaded === null)
        {
            return;
        }

        let changes = Object.values(pending).sort((a, b) => a.name.localeCompare(b.name) || a.date.localeCompare(b.date));

        Modal.confirm({
            title: `Push ${changes.length} change(s) to the channel?`,
            width: isMobile === true ? '100%' : 520,
            content: (
                <div style={{maxHeight: '50vh', overflow: 'auto'}}>
                    {changes.map(c => <div key={`${c.id}|${c.date}`}>{`${c.name} (${c.id}), ${moment(c.date).format('DD/MM/YYYY')}: ${c.from} -> ${c.to}`}</div>)}
                </div>
            ),
            okText: 'Save',
            cancelText: 'Cancel',
            onOk: () => saveData(changes)
        });
    }

    async function saveData(changes) {
        if(saving === true)
        {
            return;
        }

        setSaving(true);

        let body = {
            avail: changes.map(c => ({id: c.id, noOTA: c.noOTA, date: c.date})),
            hotel: parseInt(loaded.hotel),
            start: loaded.start.format('YYYY-MM-DD'),
            end: loaded.end.format('YYYY-MM-DD')
        };

        try
        {
            await post(`/api/channel/available`, body)
            if (response.ok)
            {
                successN(`Online Sales Control: ${changes.length} change(s) saved.`);
            }
            else
            {
                if(response.status === 401)
                {
                    localStorage.removeItem('session');
                    window.location.reload();
                    return;
                }
                else
                {
                    errorN(`Save - ${response.status}: ${response.statusText}. Please contact the administrator.`);
                }
            }
        }
        catch(err)
        {
            errorN(`Error Save: ${err}. Please contact the administrator.`);
        }

        setSaving(false);
        await loadData(loaded.hotel, loaded.start, loaded.end);
    }

    let columns = [
        {title: 'ID', dataIndex: 'id', key: 'id', fixed: 'left', width: 60},
        {title: 'Room Type', dataIndex: 'name', key: 'name', fixed: 'left', width: 160},
    ];

    for(let date of dates)
    {
        columns.push({
            title: moment(date).format('DD/MM ddd'),
            key: date,
            width: 90,
            align: 'center',
            onCell: (row) => ({
                onClick: () => { if(saving === false) toggleCell(row, date) },
                style: {
                    cursor: 'pointer',
                    background: pending[`${row.id}|${date}`] !== undefined ? '#ffe58f' : (isStopped(row.cells[date]) ? '#fff1f0' : undefined)
                }
            }),
            render: (text, row) => {
                let cell = row.cells[date];
                if(cell === undefined || cell.noOTA === undefined || cell.noOTA === null)
                {
                    return '-';
                }

                let change = pending[`${row.id}|${date}`];

                return (
                    <div title={`Channel avail: ${cell.avail}, Ratri avail: ${cell.availRatri}`}>
                        {change !== undefined ?
                            <Tag color={change.to === 'STOPPED' ? 'red' : 'green'}>{change.to === 'STOPPED' ? 'Stop' : 'Activate'}</Tag>
                            :
                            <span style={{color: isStopped(cell) ? '#cf1322' : '#389e0d', fontWeight: isStopped(cell) ? 'bold' : 'normal'}}>{isStopped(cell) ? 'STOPPED' : 'Active'}</span>
                        }
                        <div style={{fontSize: '9px', color: '#888'}}>{`avail ${cell.avail !== undefined && cell.avail !== null ? cell.avail : '-'}`}</div>
                    </div>
                );
            }
        });
    }

    if(access.stopSale !== true)
    {
        return (
            <>
                <div style={{ backgroundImage:`url("/header-bg7.png")`, color:'black', fontSize: '18px', paddingLeft: '15px', paddingTop: '15px',paddingBottom: '15px',marginTop: '0px'}}>
                    &nbsp;&nbsp;<StopOutlined />
                    &nbsp;&nbsp;Online Sales Control
                </div>
                <div style={{padding: '20px'}}>
                    <Alert type="error" showIcon message="You do not have access to Online Sales Control." />
                </div>
            </>
        );
    }

    return (
        <>
        <div style={{ backgroundImage:`url("/header-bg7.png")`, color:'black', fontSize: '18px', paddingLeft: '15px', paddingTop: '15px',paddingBottom: '15px',marginTop: '0px'}}>
        &nbsp;&nbsp;<StopOutlined />
        &nbsp;&nbsp;Online Sales Control
        </div>
        <Layout style={{height: isMobile === true ? '70vh':'74vh'}}>

            <Spin spinning={loading || saving}>
            <Content>
                <div style={{padding: '20px', margin: '0px 0',height:'72vh',overflow:'auto'}}>

                    {syncPause !== null ?
                        <Alert style={{marginBottom: '10px'}} type="warning" showIcon message={`Channel sync is paused until ${syncPause}`} />
                        : null
                    }

                    <Form layout="vertical">
                        <Space wrap>
                            <Form.Item label="Property">
                                <Select
                                    style={{minWidth: '220px'}}
                                    value={property}
                                    disabled={!admin}
                                    onChange={onPropertyChange}
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Property">
                                    {propertyList.map(value => <Option key={value.id} value={value.id}>{value.name}</Option>)}
                                </Select>
                            </Form.Item>

                            <Form.Item label="Start Date">
                                <DatePicker value={startDate} onChange={onStartChange} allowClear={false} format="DD/MM/YYYY" />
                            </Form.Item>

                            <Form.Item label="End Date">
                                <DatePicker value={endDate} onChange={onEndChange} allowClear={false} format="DD/MM/YYYY" />
                            </Form.Item>

                            <Button style={{marginTop:'7px'}} onClick={onLoad} type="primary" disabled={saving}>Load</Button>

                            <Button style={{marginTop:'7px'}} onClick={onSave} type="primary" danger disabled={pendingCount === 0 || saving} loading={saving}>
                                {`Save${pendingCount > 0 ? ` (${pendingCount})` : ''}`}
                            </Button>
                        </Space>
                    </Form>

                    <div style={{fontSize: '11px', color: '#888', marginBottom: '8px'}}>
                        Click a cell to mark it for Stop / Activate. Click again to undo. Nothing is sent until you press Save.
                    </div>

                    <Table dataSource={rows} columns={columns} rowKey="id" loading={loading}
                           scroll={{ x: 250 + (dates.length * 90)}}
                           bordered
                           size="small"
                           pagination={false}
                    >
                    </Table>

                </div>
            </Content>
            </Spin>
        </Layout>
        </>
    );
}

export default SalesControl
